import { from } from '.';

/** HREF newtype representing a hyperlink reference (URL) */
export type HREF = {
    value: string;
    readonly __tag: unique symbol;
}

export const to_url = (x: HREF) => new URL(from(x));
